module.exports = __webpack_public_path__ + "static/media/omil.28ea4330.webp";